
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: 'auto'
        },
        btn: {
            type: Boolean,
            default: false
        },
        ismyProduct: {
            type: Boolean,
            default: false
        },
        showClose: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {}
    },
    methods: {
        closeModal () {
            this.$emit('close')
            this.$parent.closeModel && this.$parent.closeModel()
            this.$store.commit('ry/SET_AGREEMENT_INFO', {})
        }
    }
}
